/**
 * This file was automatically generated by ontology-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file in
 * tools/ontology-generator/src/nodespec/relationships.json and re-run the generator.
 */

export const RELATIONSHIP_TYPES = [
  'HAS_SITE',
  'HAS_PROCESS',
  'HAS_COMPUTE',
  'HAS_SOAP_ENDPOINT',
  'USES_CONTRACT',
  'DECLARES_OPERATION',
  'HAS_LINE',
  'HAS_PRODUCTION_GOAL',
  'ACCOMPLISHES',
  'NETWORKS_WITH',
  'HAS_SUBPROCESS',
  'INSTANTIATES',
  'HAS_SUBLINE',
  'FEEDS',
  'HAS_TAG_PROVIDER',
  'HAS_DATABASE',
  'HAS_PSS_TAG',
  'HAS_EVENT_JOURNAL',
  'PROVIDES',
  'CONTAINS',
  'CALCULATED_BY',
  'DERIVES_FROM',
  'CONTAINS_TABLE',
  'USES_DATABASE',
  'USES_TABLE',
  'HAS_EQUIPMENT',
  'HAS_PART',
  'HAS_PROPERTY',
  'HAS_OBSERVABLE',
  'HAS_SETPOINT',
  'CONNECTS_TO',
  'MEASURED_BY',
  'TRACKS_GOAL',
  'TARGET_VALUE_FROM',
  'SET_BY',
  'STORES',
  'MATERIALIZES',
  'MERGED_WITH',
  'BELONGS_TO',
  'HAS_TAG',
  'READS_TAG',
  'WRITES_TAG',
  'USES_TYPE',
  'TRIGGERS',
  'GATES',
  'INHIBITS',
  'CONTROLS',
  'COORDINATES',
  'HAS_PATTERN',
  'HAS_FLOW',
  'SAFETY_CRITICAL',
  'RELATES_TO',
  'HAS_MEMBER',
  'INSTANCE_OF',
  'HAS_COMPONENT',
  'BINDS_TO',
  'INHERITS_FROM',
  'CALLS_FUNCTION',
  'USES_QUERY',
  'HAS_EVENT_SCRIPT',
  'VISUALIZES',
  'REFERENCES',
  'MAPS_TO_TAG',
  'MAPS_TO_CONTROL_TAG',
  'MAPS_TO_TYPE',
  'OF_TYPE',
  'EXHIBITS_SYMPTOM',
  'CAN_OBSERVE',
  'INDICATES',
  'INDUCES',
  'CAUSED_BY',
  'HAS_INTENT',
  'HAS_PHRASE',
  'USES_EQUIPMENT',
  'RAN_ON',
  'FOR_PRODUCT',
  'FULFILLED_BY',
  'LOCATED_IN',
  'BATCH_OF',
  'PRODUCES',
  'HAS_OPERATION',
  'EXECUTED_ON',
  'AFFECTS_BATCH',
  'OCCURRED_ON',
  'HAS_QUALITY_RESULT',
  'PART_OF',
  'CONSUMES',
  'AFFECTS',
  'RELATED_TO',
  'PROCEDURE_FOR',
  'APPLIES_TO_PRODUCT',
  'REQUIRES_PART',
  'REQUIRES_SKILL_LEVEL',
  'SUPPLIED_BY',
  'MANUFACTURED_BY',
  'HAS_UTILITY',
  'REQUIRES_UTILITY',
  'MAPS_TO_CONTROLLER',
  'CONTROLLED_BY',
  'COMPOSES',
  'MONITORED_BY',
  'HAS_ALARM',
  'HAS_ALARM_DEFINITION',
  'HOSTS',
  'SUPERVISES',
  'HAS_JOB',
  'CALLS_JOB',
  'READ_BY',
  'WRITTEN_BY',
  'USED_BY',
  'DEFINES',
  'OUTPUTS_TO',
  'USES_VISION_DATA',
  'MAPS_TO_ROBOT_SIGNAL',
  'HAS_IO_TAG',
  'REQUIRES_LABOR',
  'HAS_LINE_OPERATION',
  'RECOVERS',
  'FALLBACK_FOR',
  'HAS_CREW_REQUIREMENT',
  'COVERS',
  'STAFFED_BY',
  'SCHEDULED_BY',
  'TRIGGERED_BY',
  'ASSIGNED_TO',
  'MOUNTED_ON',
  'WIRED_TO',
  'SIGNAL_FLOWS_TO',
  'EXPOSES',
  'PARENT_OF',
  'DERIVED_FROM',
  'HAS_PARAM_GROUP',
  'PARTNER_OF',
  'SENSED_BY',
  'ACTUATES',
  'PROTECTS',
  'SOLVED_BY',
  'HAS_PROTECTIVE_FUNCTION',
  'IN_SECTION',
  'CITES',
  'FOR_SCENARIO',
  'HAS_ACTUATOR',
  'ASSOCIATED_WITH',
  'IMPLEMENTED_BY',
  'MAPS_TO_SAFETY_POINT',
  'APPLIES_TO',
  'HAS_SYMPTOM',
  'MAY_BE_CAUSED_BY'
] as const

export type RelationshipType = (typeof RELATIONSHIP_TYPES)[number]
